import ImageMarvel from "../../images/marvel1.png";
import ImageToDoList from "../../images/td.png";
import ImageNothing from "../../images/nothing.png";
import ImageCryptoverse from "../../images/cryptoverse.png";
import ImageHeroes from "../../images/heroes.png";
import ImageAnime from "../../images/anime.png";

export const portfolioData = [
  {
    id: 2,
    name: "Anime Universe",
    image: ImageAnime,
    link: "https://shashkov-anime-universe.netlify.app/",
  },

  {
    id: 2,
    name: "Modern Todo-List",
    image: ImageToDoList,
    link: "https://shashkov-modern-todo-list.netlify.app/",
  },

  {
    id: 2,
    name: "Marvel Information Portal",
    image: ImageMarvel,
    link: "https://shashkov-marvel-information-portal.netlify.app/",
  },

  {
    id: 2,
    name: "Cryptoverse",
    image: ImageCryptoverse,
    link: "https://cryptoverce-shashkov.netlify.app/",
  },

  {
    id: 2,
    name: "Hero admin panel template",
    image: ImageHeroes,
    link: "https://shashkov-hero-admin-panel-template.netlify.app/",
  },

  {
    id: 3,
    name: "Nothing here.....",
    image: ImageNothing,
    link: "http://www.thereisnothinghere.com/",
  },

  /* {
      id: 2,
      name: "Random online store",
      image: ImageNothing,
      link: 'http://www.thereisnothinghere.com/',
    }, */
];

export const filterData = [
  {
    filterId: 1,
    label: "All",
  },

  {
    filterId: 2,
    label: "Development",
  },

  {
    filterId: 3,
    label: "Something else",
  },
];
